import { Link } from 'react-router-dom';
import {
    RiFacebookFill,
    RiTwitterXFill,
    RiInstagramLine,
    RiLinkedinFill,
    RiYoutubeFill 
     
} from 'react-icons/ri';

const Footer = () => {
    const footerLinks = [
        {
            title: "DISCOVER",
            links: [
                { label: "Flora & Fauna", path: "/flora-fauna" },
                { label: "Regional Travel", path: "/travel" },
                { label: "Species Catalog", path: "/flora-fauna" },
                { label: "Interactive Map", path: "/travel" }
            ]
        },
        {
            title: "INSIGHTS",
            links: [
                { label: "Latest News", path: "/news" },
                { label: "Publications", path: "/publications" },
                { label: "Research Papers", path: "/publications" },
                { label: "Impact Reports", path: "/" }
            ]
        },
        {
            title: "ORGANIZATION",
            links: [
                { label: "About Us", path: "/about" },
                { label: "Our Team", path: "/about" },
                { label: "Careers", path: "/about" },
                { label: "Contact", path: "/contact" }
            ]
        },
        {
            title: "CONNECT",
            links: [
                { label: "Join the Mission", path: "/contact" },
                { label: "Partner with Us", path: "/contact" },
                { label: "Press & Media", path: "/news" },
                { label: "Donate", path: "/contact" }
            ]
        }
    ];

    return (
        <footer className="relative bg-black overflow-hidden selection:bg-emerald-500/30">
            {/* Cinematic Forest Background */}
            <div className="absolute inset-0 z-0">
                <img
                    src="https://lh3.googleusercontent.com/pw/AP1GczMiytZi4uyH_UUs8fuGNAdqvFSmqJeJXWx4wRouoY1HIl9bbcFA8MDa1DbC4idPyI4wL2Uu71SHhAg32_DNoAxTOIL7JEMx-q7ytNu_52P1If8HfkBYyZ_6nGJ7vKCUKSVmO02OnnEzbLwhAYUy3CX4MA=w1920-h910-s-no-gm?authuser=0"
                    alt="Forest Context"
                    className="w-full h-full object-cover opacity-400 grayscale-[0.3]"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black via-black/80 to-transparent" />
            </div>

            <div className="relative z-10 mx-auto max-w-7xl px-6 lg:px-10 pt-24 pb-12">
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-12 lg:gap-8">

                    {/* Brand Column */}
                    <div className="lg:col-span-1">
                        <div className="flex items-center gap-3 group cursor-pointer mb-8">
                            <img
                                src="/images/mlogo.png"
                                alt="COE Logo"
                                className="w-40 object-contain"
                            />
                        </div>
                    </div>

                    {/* Links Grid */}
                    <div className="lg:col-span-4 grid grid-cols-2 md:grid-cols-4 gap-8">
                        {footerLinks.map((section) => (
                            <div key={section.title} className="flex flex-col gap-6">
                                <h3 className="text-[11px] font-black tracking-[0.2em] text-amber-300 transition-colors uppercase font-display">
                                    {section.title}
                                </h3>
                                <ul className="flex flex-col gap-4">
                                    {section.links.map((link) => (
                                        <li key={link.label}>
                                            <Link
                                                to={link.path}
                                                className="text-[15px] font-bold text-white hover:text-emerald-400 transition-colors duration-300 font-sans"
                                            >
                                                {link.label}
                                            </Link>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        ))}
                    </div>
                </div>

                {/* Bottom Bar Segment */}
                <div className="mt-20 pt-8 border-t border-white/10 flex flex-col lg:flex-row justify-between items-center gap-8">
                    <div className="flex flex-col md:flex-row items-center gap-4 text-[11px] text-white/50 font-bold tracking-tight font-sans">
                        <p>The Conservation of Environment is a 501(c)(3) Nonprofit registered in the US under EIN: 13-3377893.</p>
                        <span className="hidden md:block">|</span>
                        <p>© Copyright 1987 - 2026, COE Studio</p>
                    </div>

                    <div className="flex items-center gap-6">
                        <div className="flex items-center gap-4 text-[11px] text-white font-bold tracking-tight border-r border-white/10 pr-6">
                            <a href="#" className="hover:text-emerald-400 transition-colors uppercase">Privacy Policy</a>
                            <span>|</span>
                            <a href="#" className="hover:text-emerald-400 transition-colors uppercase">Cookie Policy</a>
                            <span>|</span>
                        </div>

                        <div className="flex items-center gap-3">
                            {[
                                { icon: RiFacebookFill, label: 'Facebook' },
                                { icon: RiTwitterXFill, label: 'Twitter' },
                                { icon: RiLinkedinFill, label: 'LinkedIn' },
                                { icon: RiInstagramLine, label: 'Instagram' },
                                { icon: RiYoutubeFill, label: 'YouTube' }
                            ].map(({ icon: Icon, label }) => (
                                <a
                                    key={label}
                                    href="#"
                                    className="w-8 h-8 rounded-full border border-white/20 flex items-center justify-center text-white hover:bg-white hover:text-black transition-all duration-300"
                                    title={label}
                                >
                                    <Icon size={14} />
                                </a>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
